import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as SidebarActions } from "../../store/ducks/sidebar";
import compose from "recompose/compose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Avatar from "@material-ui/core/Avatar";
import { Scrollbars } from "react-custom-scrollbars";
import Button from "@material-ui/core/Button";
import classNames from "classnames";
import MenuItems from "../MenuItems";
import MenuItemsFit from "../MenuItemsFit";
import Divider from "@material-ui/core/Divider";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { NavLink } from "react-router-dom";
import { Creators as ModalPhotoActions } from "../../store/ducks/modalPhoto";
import PhotoForm from "../../components/Forms/Usuarios/photo";
import SenhaForm from "../../components/Forms/Usuarios/senha";
import Modal from "../../components/DraggableModal";
import { Creators as AuthActions } from "../../store/ducks/auth";
import { Creators as UsuariosActions } from "../../store/ducks/usuarios";
import { Creators as StorePageActions } from "../../store/ducks/PageStores/usuariosStores";
import AvatarImg from "../../assets/avatar.png";

const drawerWidth = "25rem";

const styles = theme => ({
  drawerPaper: {
    position: "relative",
    background: localStorage.getItem("@ecorban-app:theme")
      ? localStorage.getItem("@ecorban-app:theme")
      : "#2f4050",
    width: drawerWidth,
    display: "flex",
    justifyContent: "space-between",
    transition: "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important",
    overflow: "hidden"
  },
  drawerFooter: {
    display: "flex",
    height: "6rem",
    minHeight: "6rem",
    borderTop: "thin solid rgba(0, 0, 0, 0.12)"
  },
  drawerBody: {
    flexGrow: "1",
    overflow: "auto"
  },
  slideMenuButton: {
    width: "100%",
    height: "100%",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    padding: "2rem"
  },
  "content-left": {
    marginLeft: -drawerWidth
  },
  "content-right": {
    marginRight: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  "contentShift-left": {
    marginLeft: 0
  },
  "contentShift-right": {
    marginRight: 0
  }
});

class Sidebar extends React.Component {
  state = {
    anchorEl: null,
    modalSenha: false
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handlePhoto = id => {
    this.props.setAction("PHOTO");
    this.props.getUsuarios(id);
    this.handleClose();
  };

  handleSenha = () => {
    this.setState({
      modalSenha: true
    });
    this.handleClose();
  };

  render() {
    const { classes } = this.props;
    const tenant = localStorage.getItem("@ecorban-app:tenant");
    const { anchorEl } = this.state;

    const drawer = (
      <Drawer
        id="sidebar"
        variant="persistent"
        open={this.props.open}
        className={classNames({
          fitMenu: this.props.fit
        })}
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <div className="drawerHeader">
          <Avatar
            aria-owns={anchorEl ? "simple-menu" : null}
            onClick={this.handleClick}
            className="cursor-pointer avatar-header"
            src={this.props.avatar ? this.props.avatar : AvatarImg}
          />
          <div className="dados-usuario">
            <p className="nome-usuario truncate-name">
              {this.props.name}
              <span className="truncate-name">{this.props.company}</span>
              <small>Online</small>
            </p>
          </div>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            className="menu-suspenso"
          >
            {this.props.master && (
              <NavLink to={`/${tenant}/empresa`}>
                <MenuItem>
                  <i className="fa fa-building-o mr1" />
                  Empresa
                </MenuItem>
              </NavLink>
            )}
            <MenuItem
              onClick={() => {
                this.handlePhoto(this.props.id);
              }}
            >
              <i className="fa fa-camera mr1" />
              Foto
            </MenuItem>
            <MenuItem
              onClick={() => {
                this.handleSenha();
              }}
            >
              <i className="fa fa-key mr1" />
              Alterar Senha
            </MenuItem>
            <MenuItem
              onClick={() => {
                this.props.logout();
              }}
            >
              <i className="fa fa-sign-out mr1" />
              Sair
            </MenuItem>
          </Menu>
        </div>
        <Divider />
        <Scrollbars className={classes.drawerBody}>
          {this.props.fit ? <MenuItemsFit /> : <MenuItems />}
        </Scrollbars>
        <div className={classes.drawerFooter}>
          <Button
            className={classes.slideMenuButton}
            onClick={() =>
              this.props.fit
                ? this.props.unfitSideBar()
                : this.props.fitSideBar()
            }
          >
            <i className="fa fa-angle-left" />
          </Button>
        </div>
        <Modal
          open={this.props.modalPhoto.open}
          onClose={() => this.props.closePhotoModal()}
          className="modal"
        >
          <div>
            <div className="modalHeader">
              Foto do usuário{" "}
              {this.props.usuarios.item.name
                ? this.props.usuarios.item.name.toUpperCase()
                : ""}
            </div>
            <div className="modalBody">
              <PhotoForm />
            </div>
          </div>
        </Modal>

        <Modal
          open={this.state.modalSenha}
          onClose={() => this.setState({ modalSenha: false })}
          className="modal"
        >
          <div>
            <div className="modalHeader">Alterar senha</div>
            <div className="modalBody">
              <SenhaForm
                closeModalSenha={() => this.setState({ modalSenha: false })}
              />
            </div>
          </div>
        </Modal>
      </Drawer>
    );

    return drawer;
  }
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  open: state.sidebar.open,
  fit: state.sidebar.fit,
  pages: state.pages,
  avatar: state.permissions.avatar,
  name: state.permissions.name,
  id: state.permissions.id,
  modalPhoto: state.modalPhoto,
  usuarios: state.usuarios,
  master: state.permissions.master,
  company: state.permissions.company
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...SidebarActions,
      ...ModalPhotoActions,
      ...AuthActions,
      ...UsuariosActions,
      ...StorePageActions
    },
    dispatch
  );

export default compose(
  withStyles(styles, { name: "Sidebar" }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js